import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

import logoImg from "../../assets/images/logo2.png";

/**
 * KARSILAMA KARTI
 *
 * Onceki hali sablondan (Skote) geliyordu: mor bir illustrasyon, "Hosgeldiniz!"
 * yazisi ve bos birakilmis iki sutun. Ne kime ait oldugu belliydi ne de bir ise
 * yariyordu.
 *
 * Yeni hali panelin kime ait oldugunu (BES logosu + kullanici adi), gunun
 * tarihini ve en sik yapilan uc isi tek karta topluyor. Onay kuyrugundaki
 * kayit sayisi burada da gorunuyor; kullanici menuye bakmadan da fark ediyor.
 */

const selamla = () => {
  const saat = new Date().getHours();
  if (saat < 6) return "İyi geceler";
  if (saat < 12) return "Günaydın";
  if (saat < 18) return "İyi günler";
  return "İyi akşamlar";
};

const bugun = () =>
  new Date().toLocaleDateString("tr-TR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

// Oturum bilgisi bozuksa kart cokmemeli
const oturum = () => {
  try {
    return JSON.parse(localStorage.getItem("authUser")) || {};
  } catch (e) {
    return {};
  }
};

const WelcomeComp = ({ onayBekleyen }) => {
  const kullanici = oturum();
  const ad = kullanici.NameSurname || kullanici.Users_Name_Surname || "Yönetici";
  const mail = kullanici.MailAdress || kullanici.Users_MailAddress || "";

  return (
    <Card className="bes-karsilama h-100">
      <CardBody className="d-flex flex-column">
        <div className="d-flex align-items-center gap-3">
          <img src={logoImg} alt="Berlin Esnaf" className="bes-karsilama__logo" />
          <div className="flex-grow-1">
            <p className="bes-karsilama__selam mb-0">{selamla()},</p>
            <h4 className="bes-karsilama__ad">{ad}</h4>
            {mail ? <p className="bes-karsilama__mail">{mail}</p> : null}
          </div>
        </div>

        <span className="bes-karsilama__tarih">
          <i className="bx bx-calendar align-middle me-1" />
          {bugun()}
        </span>

        <div className="d-flex flex-wrap gap-2 mt-auto">
          <Link
            to="/moderation"
            className={
              "bes-karsilama__islem" +
              (onayBekleyen > 0 ? " bes-karsilama__islem--uyari" : "")
            }
          >
            <i className="bx bx-shield-quarter" />
            Onay Bekleyenler
            {onayBekleyen > 0 ? (
              <span className="rozet">{onayBekleyen}</span>
            ) : null}
          </Link>

          <Link to="/PopupList" className="bes-karsilama__islem">
            <i className="bx bx-bell" />
            Bildirim Gönder
          </Link>

          <Link to="/news" className="bes-karsilama__islem">
            <i className="bx bx-news" />
            Aktüel Ekle
          </Link>
        </div>
      </CardBody>
    </Card>
  );
};

WelcomeComp.propTypes = {
  onayBekleyen: PropTypes.number,
};

export default WelcomeComp;
